<template>
  <page-view
    :title="giveaway ? giveaway.title : state === 'loading' ? 'Loading giveaway' : 'Could not find giveaway'"
    :backLink="backLink"
    :backText="backText"
  >
    <template v-slot:id>
      <template v-if="giveaway">
        <id :id="giveaway.id" />
      </template>
    </template>

    <template v-slot:header-right>
      <template v-if="giveaway">
        <dots class="border left m-r-2">
          <ul>
            <li @click="deleteGiveaway">
              <i class="icon-close-medium" />
                Delete giveaway
            </li>
          </ul>
        </dots>
      </template>
    </template>

    <template v-if="giveaway">
      <table-list :overflowAll="true">
        <template v-slot:table-header>
          <div class="list-header p-a-md-3 ai-md-c">
            <div class="d-f f-1 p-a-2 p-a-md-0">
              <div class="button ml-a">
                <!--<Button icon="accounting-24" class="medium only-text keep-hover blue minimal-border-radius with-extra-side-padding" @click="exportGiveaway">Export</Button>-->
              </div>
            </div>
          </div>
        </template>
        <tr class="header f-w">
          <th class="w-100p">Email</th>
          <th class="w-25p">Created</th>
        </tr>
        <template v-if="customers && customers.length > 0">
          <a
            :href="`/customer/${customer.id}`"
            :key="customer.id"
            @click.prevent="handleLink($event, `/customer/${customer.id}`)"
            v-for="customer in customers"
          >
            <td>
              <div class="blue" v-if="!customer.opted_out">{{ customer.email }}</div>
              <div class="gray" v-else>User has opted out</div>
            </td>
            <td>{{ getCreatedAt(customer.created_at) }}</td>
          </a>
        </template>
        <template v-else>
          <a class="empty-list">
            <td colspan="4" class="p-a-4">
              No participants
            </td>
          </a>
        </template>
      </table-list>
    </template>
    <template v-else>
      <div class="d-f f-1 ai-c jc-c" v-if="state === 'loading'">
        <div class="loading-spinner large"></div>
      </div>
      <div class="d-f f-1 ai-c jc-c" v-else-if="state === 'error'">
        <p>Could not load giveaway</p>
      </div>
    </template>
  </page-view>
</template>

<script>

import moment from 'moment';
import { exportToCsv } from '@/utils';

import TableList from '@/components/Lists/Table.vue';
import Dots from '@/components/Dots.vue';

export default {
  components: {
    Dots,
    TableList,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      backLink: '/customers/giveaway',
      backText: 'Back to customer giveaways',
      giveaway: null,
      state: 'loading',
      customers: [],
      current_page: 1,
      per_page: 20,
      max_page: 1,
      total_customers: 0,
      direction: 'desc',
      sort: 'created',
    };
  },
  methods: {
    async exportGiveaway() {
      const data = await this.$store.dispatch('Giveaway/export', this.id);
      if (!data) {
        swal({ title: 'An error occured', text: 'Could not export customer(s)', icon: 'error' });
        return;
      }

      exportToCsv(`${this.giveaway.title.replace(' ', '_')}_export.csv`, data);
    },
    async getGiveaway() {
      const giveaway = await this.$store.dispatch('Giveaway/getGiveaway', { id: this.id, doCommit: false });
      this.giveaway = giveaway;

      if (giveaway) {
        this.getCustomers();
      }
    },
    async getCustomers() {
      const payload = {
        page: this.current_page,
        per_page: this.per_page,
        sort: this.sort,
        direction: this.direction,
        giveaway_id: this.id,
      };

      const {
        customers,
        total,
        pagination: {
          current_page = 1,
          max_page = 1,
        } = {},
      } = await this.$store.dispatch('Customers/getCustomers', payload);

      this.customers = customers;
      this.total_customers = total;
      this.current_page = current_page;
      this.max_page = max_page;
    },
    getCreatedAt(date) {
      return Math.abs(moment().diff(date, 'days')) < 2 ? moment(date).from(moment()) : this.$options.filters.formatdate(date, 'MMM Do YYYY');
    },
    async deleteGiveaway() {
      const willDelete = await swal({
        title: this.$t('errors.are_you_sure'), text: 'This will remove giveaway', icon: 'warning', buttons: true, dangerMode: true,
      });

      if (!willDelete) {
        return;
      }

      const deleted = await this.$store.dispatch('Giveaway/deleteGiveaway', this.id);
      if (!deleted) {
        swal({ title: 'An error occured', text: 'Could not delete giveaway', icon: 'error' });
      }
      this.$router.push(this.backLink);
    },
  },
  async mounted() {
    await this.getGiveaway();
    this.state = '';

    const lastRoute = this.$store.getters['Theme/lastRoute'];
    if (lastRoute && lastRoute.path.includes('customers')) {
      this.backLink = lastRoute.fullPath;
    } else if (lastRoute && lastRoute.path.includes('broadcast')) {
      this.backLink = lastRoute.fullPath;
      this.backText = 'Back to Broadcast';
    }
  },
};
</script>
